import SkillPage from "../Assets/img1.webp";
import "./SkillSetStyle.css";
const SkillSet = () => {
    return (
        <div className="my skill">
            <div className="skill-container">
                <img src={SkillPage} alt="SkillSet Img" />
                <h1>Here is My SkillSet</h1>
                <div className="skill-list">
                    <div className="programming">
                        <h2>C/C++</h2>
                        <p>CPP is my Major Programming Language. I have good hands over there with 3 years of experience.</p>
                        <div className="skill-bar">
                            <div className="detailskill">
                                <span>CPP</span>
                                <span>90%</span>
                            </div>
                            <div className="bar">
                                <div className="cpp-bar"></div>
                            </div>
                        </div>
                    </div>
                    <div className="programming">
                        <h2>DSA</h2>
                        <p>I have solved more than 250 DSA problems across the various online coding platform.</p>
                        <div className="skill-bar">
                            <div className="detailskill">
                                <span>DSA</span>
                                <span>60%</span>
                            </div>
                            <div className="bar">
                                <div className="dsa-bar"></div>
                            </div>
                        </div>
                    </div>
                    <div className="programming">
                        <h2>React Js</h2>
                        <p>I have learnt React js after developing the good and fair knowledge in Basic Javascript and ES-6 and I have 6 month of experience in it.</p>
                        <div className="skill-bar">
                            <div className="detailskill">
                                <span>React Js</span>
                                <span>75%</span> 
                            </div>
                            <div className="bar">
                                <div className="react-bar"></div>
                            </div>
                        </div>
                    </div>
                    <div className="programming">
                        <h2>JavaScript</h2>
                        <p>I used to practice Javascript through beginner level projects including HTML and CSS. I have 1 year of experience in JS.</p>
                        <div className="skill-bar">
                            <div className="detailskill">
                                <span>JavaScript</span>
                                <span>60%</span> 
                            </div>
                            <div className="bar">
                                <div className="js-bar"></div>
                            </div>
                        </div>
                    </div>
                    <div className="programming">
                        <h2>CSS</h2>
                        <p>Using CSS, I learnt to create style and layout in web pages and Till now I have a fair knowledge and good practice to make a web page responsive.</p>
                        <div className="skill-bar">
                            <div className="detailskill">
                                <span>CSS</span>
                                <span>70%</span>
                            </div>
                            <div className="bar">
                                <div className="css-bar"></div>
                            </div>
                        </div>
                    </div>
                    <div className="programming">
                        <h2>HTML</h2>
                        <p>I have 1.5 years of experience in HTML. With the help of HTML, I learnt to use various tags and elements to create web pages.</p>
                        <div className="skill-bar">
                            <div className="detailskill">
                                <span>HTML</span>
                                <span>70%</span>
                            </div>
                            <div className="bar">
                                <div className="html-bar"></div>
                            </div>
                        </div>
                    </div>
                    <div className="programming">
                        <h2>SQL</h2>
                        <p>SQL helped me to undestand the multiple operations with data, including query, update, insert and delete.</p>
                        <div className="skill-bar">
                            <div className="detailskill">
                                <span>SQL</span>
                                <span>70%</span>
                            </div>
                            <div className="bar">
                                <div className="sql-bar"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SkillSet;